import React, { forwardRef } from 'react';
import { useField } from 'formik';
import { Input } from 'components/shadcn/ui/input';
import { Label } from 'components/shadcn/ui/label';
import { cn } from 'components/shadcn/lib/utils';

const HGFormInput = forwardRef(
    (
        {
            name,
            className,
            inputClassName,
            label,
            startAdornment,
            endAdornment,
            ...props
        },
        ref
    ) => {
        const [field, meta] = useField(name);
        const errorOnSubmit = meta.error && meta.touched;
        const hasStartAdornment = !!startAdornment;
        const hasEndAdornment = !!endAdornment;

        return (
            <div className={cn('relative flex-col space-y-1', className)}>
                {label && (
                    <Label
                        htmlFor={name}
                        className={cn(
                            'text-foreground',
                            errorOnSubmit && 'text-red-500'
                        )}
                    >
                        {label}
                    </Label>
                )}
                <div className="relative flex items-center">
                    {hasStartAdornment && (
                        <div className="absolute left-2 z-10 flex items-center">
                            {startAdornment}
                        </div>
                    )}
                    <Input
                        id={name}
                        {...field}
                        {...props}
                        className={cn(
                            'placeholder:text-secondary-foreground',
                            hasStartAdornment && 'pl-10',
                            hasEndAdornment && 'pr-10',
                            errorOnSubmit &&
                                'border-red-500 focus-visible:ring-red-500',
                            inputClassName
                        )}
                        value={field.value ?? ''}
                        ref={ref}
                    />
                    {hasEndAdornment && (
                        <div className="absolute right-2 z-10 flex items-center">
                            {endAdornment}
                        </div>
                    )}
                </div>
                {errorOnSubmit && (
                    <p className="text-xs text-red-500">{meta.error}</p>
                )}
            </div>
        );
    }
);

export default HGFormInput;
